import { useCallback } from 'react'

const STEP_SECONDS = 5
const VOLUME_STEP = 0.1

// Возвращает обработчик onKeyDown для навешивания на контейнер плеера
// (у контейнера должен быть tabIndex, иначе он не сможет получить фокус
// и клавиатурные события до него не долетят).
export function useHotkeys({ enabled = true, toggle, seekBy, setVolume, toggleMute, requestFullscreen, volume }) {
    return useCallback((e) => {
        if (!enabled) return
        // Не перехватываем стрелки/space, если фокус на нативном range-инпуте
        // (перемотка/громкость) — иначе он и сам обработает клавишу, и наш
        // хоткей сработает поверх, двигая значение дважды.
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT') return

        switch (e.key) {
            case ' ':
            case 'Spacebar':
                e.preventDefault()
                toggle()
                break
            case 'ArrowLeft':
                e.preventDefault()
                seekBy(-STEP_SECONDS)
                break
            case 'ArrowRight':
                e.preventDefault()
                seekBy(STEP_SECONDS)
                break
            case 'ArrowUp':
                e.preventDefault()
                setVolume(Math.min(1, volume + VOLUME_STEP))
                break
            case 'ArrowDown':
                e.preventDefault()
                setVolume(Math.max(0, volume - VOLUME_STEP))
                break
            case 'f':
            case 'F':
                e.preventDefault()
                requestFullscreen()
                break
            case 'm':
            case 'M':
                e.preventDefault()
                toggleMute()
                break
            default:
                break
        }
    }, [enabled, toggle, seekBy, setVolume, toggleMute, requestFullscreen, volume])
}
